// extracted by mini-css-extract-plugin
module.exports = {"input":"Input-module--input--1NANl"};